import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/FeaturedStoriesCard/FeaturedStoriesCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Tag/Tag.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/PressReleaseCard/PressReleaseCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/StoriesCard/StoriesCard.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Stories/Stories.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(nlx)/news/page.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Pagination/Pagination.module.css");
